import { TsDOM as q } from '@/scripts/core/TsDOM'
import { AnchorTile } from '@/scripts/theme/anchor-tile'

q.safeDefineElement(AnchorTile)
